import { render, staticRenderFns } from "./NameDetailProductHorizontal.vue?vue&type=template&id=89e38d40&"
import script from "./NameDetailProductHorizontal.vue?vue&type=script&lang=js&"
export * from "./NameDetailProductHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports